import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { AUTH_API_URL } from "../lib/env";
import { parseJwt } from "../lib/util";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import {
  CircularProgress,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import MaskedTextInput from "../components/MaskedTextInput";

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: localStorage.getItem("token"),
      username: "",
      password: "",
      isInfoDialogOpen: false,
      authErrorText: "",
      showPassword: false,
      ip: null,
      city: null,
      country: null,
      deviceInfo: null,
      latitude: null,
      longitude: null,
      isGeoDialogOpen: false,
      geoLoading: true,
      isOtpDialogOpen: false,
      otpCode: "",
    };
  }

  componentDidMount() {
    // geo
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setState({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            geoLoading: false,
          });
        },
        (error) => {
          console.error("Error getting user location:", error);
          this.setState({
            geoLoading: false,
          });
        },
      );
    } else {
      // display an error if not supported
      console.error("Geolocation is not supported by this browser.");
    }

    let self = this;
    axios
      .get("https://geolocation-db.com/json/", {})
      .then(function (response) {
        self.setState({
          ip: response.data.IPv4,
          city: response.data.city,
          country: response.data.country_name,
          deviceInfo: navigator.userAgent,
        });
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error.message);
      });
  }

  checkPasswordChange() {
    if (!localStorage.getItem("token")) {
      return;
    }

    if (Date.now() >= localStorage.getItem("token").exp * 1000) {
      return;
    }

    let self = this;
    axios
      .get(AUTH_API_URL + "/users/lastPasswordChange/" + this.state.username, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        console.log(response);
        self.props.history.push("/");
      })
      .catch(function (error) {
        console.log(error.message);

        if (error.message.includes("400")) {
          self.props.history.push("/profile", {
            changePassword: false,
            passwordToChange: self.state.password,
          });
        }
      });
  }

  sendOTP = async () => {
    if (!this.state.longitude && !this.state.longitude) {
      this.setState({ isGeoDialogOpen: true });
    }

    axios
      .post(AUTH_API_URL + "/authenticate", {
        username: this.state.username,
        password: this.state.password,
        ip: this.state.ip,
        city: this.state.city,
        country: this.state.country,
        deviceInfo: this.state.deviceInfo,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
      })
      .then(() => {
        this.setState({ isOtpDialogOpen: true });
      })
      .catch((error) => {
        console.log(error.message);

        if (error.message.includes("401")) {
          alert("Неверный логин или пароль. Проверьте, нет ли опечаток.");
        }
      });
  };

  signIn = async () => {
    axios
      .post(AUTH_API_URL + "/codeVerify", {
        username: this.state.username,
        otpCode: this.state.otpCode,
      })
      .then((response) => {
        localStorage.setItem("token", response.data.token);
        this.setState({ isOtpDialogOpen: false });
        this.checkPasswordChange();
      })
      .catch((error) => {
        console.error(error);
        alert(error.message);
      });
  };

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleSignIn(e) {
    e.preventDefault();

    if (!this.state.longitude && !this.state.longitude) {
      this.setState({ isGeoDialogOpen: true });
    }

    let self = this;

    axios
      .post(AUTH_API_URL + "/authenticate", {
        username: this.state.username,
        password: this.state.password,
        ip: this.state.ip,
        city: this.state.city,
        country: this.state.country,
        deviceInfo: this.state.deviceInfo,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
      })
      .then(function (response) {
        localStorage.setItem("token", response.data.token);

        self.checkPasswordChange();
        console.log("signin");
      })
      .catch(function (error) {
        console.log(error.message);
        if (error.message.includes("401")) {
          alert("Неверный логин или пароль. Проверьте, нет ли опечаток.");
        }
      });
  }

  handleCloseInfoDialog() {
    this.setState({
      isInfoDialogOpen: false,
    });
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
    console.log(this.state.showPassword);
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: "85vh" }}
        >
          <Grid item xs={12}>
            <form onSubmit={this.handleSignIn.bind(this)}>
              <Paper
                style={{
                  padding: "60px",
                  paddingBottom: "60px",
                  minWidth: "150px",
                  maxWidth: "250px",
                }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="h5" component="h3">
                      Авторизация
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      style={{ width: "100%" }}
                      id="password"
                      label={"Имя пользователя"}
                      type="text"
                      value={this.state.username}
                      onChange={this.handleChange("username")}
                      margin="normal"
                      required
                    />
                  </Grid>

                  <Grid item xs={12} style={{ paddingBottom: "20px" }}>
                    <FormControl
                      style={{ width: "100%" }}
                      sx={{ m: 1, marginTop: "normal" }}
                      variant="standard"
                    >
                      <InputLabel htmlFor="password">Пароль *</InputLabel>

                      <Input
                        id="password"
                        label={"Пароль"}
                        type={this.state.showPassword ? "text" : "password"}
                        value={this.state.password}
                        onChange={this.handleChange("password")}
                        margin="normal"
                        required
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={this.handleClickShowPassword}
                              onMouseDown={this.handleMouseDownPassword}
                            >
                              {this.state.showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    {this.state.geoLoading ? (
                      <CircularProgress size={30} />
                    ) : (
                      <>
                        {/* <Button
                          className="button"
                          disabled={
                            !this.state.username === "" &&
                            this.state.password === ""
                          }
                          style={{ marginTop: "30px", width: "100%" }}
                          type="submit"
                        >
                          Вход в систему
                        </Button> */}

                        <Button
                          variant="contained"
                          color="primary"
                          disabled={
                            this.state.username === "" ||
                            this.state.password === ""
                          }
                          onClick={this.sendOTP}
                        >
                          Продолжить
                        </Button>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            </form>
          </Grid>
        </Grid>

        <Dialog
          width={300}
          onClose={this.handleCloseInfoDialog.bind(this)}
          aria-labelledby="simple-dialog-title"
          open={this.state.isInfoDialogOpen}
        >
          <DialogTitle id="simple-dialog-title">
            <Grid container>
              <Grid item xs={6}>
                Ошибка
              </Grid>

              <Grid item xs={6} style={{ textAlign: "right" }}>
                <IconButton
                  aria-label="Close"
                  onClick={this.handleCloseInfoDialog.bind(this)}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>

          <div style={{ padding: "10px" }}>
            <Grid>
              <Grid item xs={12}>
                {this.state.authErrorText}
              </Grid>
            </Grid>
          </div>
        </Dialog>

        <Dialog
          width={300}
          onClose={() => this.setState({ isGeoDialogOpen: false })}
          aria-labelledby="simple-dialog-title"
          open={this.state.isGeoDialogOpen}
        >
          <DialogTitle id="simple-dialog-title">
            <Grid container>
              <Grid item xs={6}>
                Ошибка
              </Grid>

              <Grid item xs={6} style={{ textAlign: "right" }}>
                <IconButton
                  aria-label="Close"
                  onClick={() => this.setState({ isGeoDialogOpen: false })}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>

          <div style={{ padding: "10px" }}>
            <Grid>
              <Grid item s={12}>
                <div style={{ padding: "30px", fontSize: "20px" }}>
                  Пожалуйста, включите геолокацию!
                </div>
              </Grid>
            </Grid>
          </div>
        </Dialog>

        <Dialog open={this.state.isOtpDialogOpen}>
          <DialogTitle>Введите OTP код</DialogTitle>

          <DialogContent>
            <Typography>
              На вашу электронную почту был отправлен OTP код.
            </Typography>

            <MaskedTextInput
              label="OTP код"
              mask={"999999"}
              style={{ marginBlockStart: "2.5em" }}
              value={this.state.otpCode}
              change={(e) => this.setState({ otpCode: e.target.value })}
            />
          </DialogContent>

          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              disabled={!this.state.otpCode || this.state.otpCode.length !== 6}
              onClick={this.signIn}
            >
              Подтвердить
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default SignIn;
